import { render } from "./CameraGroupsPage.vue?vue&type=template&id=391c6b4b&ts=true"
import script from "./CameraGroupsPage.vue?vue&type=script&lang=ts"
export * from "./CameraGroupsPage.vue?vue&type=script&lang=ts"

import "./CameraGroupsPage.vue?vue&type=style&index=0&id=391c6b4b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__